const getEndpoint = path => `${process.env.VUE_APP_PROVIDER}/${path}`
const isDevelopment = () => process.env.NODE_ENV === 'development'

export const getDefaultParams = () => {
  const params = {}

  if (isDevelopment) {
    params.development = true
  }

  return params
}

export const getDomains = async () => {
  const { data: domains } = await window.axios.get(getEndpoint('onboarding/listdomains'), { params: getDefaultParams() })

  return domains
}

export const requestCertificate = async (domain) => {
  const { data: response } = await window.axios.post(getEndpoint('onboarding/requestcertificate'), { domain })

  return response
}

export const createCloudFrontDistribution = async (domain) => {
  const { data: response } = await window.axios.post(getEndpoint('onboarding/createcloudfrontdistribution'), { domain })

  return response
}

export const queryCloudFrontAliasStatus = async (domain) => {
  const { data: cloudFrontAliasStatus } = await window.axios.post(getEndpoint('onboarding/hascloudfrontalias'), { domain })

  return cloudFrontAliasStatus
}

export const createCloudFrontAlias = async (domain) => {
  const { data: response } = await window.axios.post(getEndpoint('onboarding/createcloudfrontalias'), { domain })

  return response
}

export default {
  getDomains,
  requestCertificate,
  createCloudFrontDistribution,
  queryCloudFrontAliasStatus
}
